import * as loadingAction from "../../../store/loading/action";

import {
    ACCESS_TOKEN_PASS,
    ACCESS_TOKEN_USER,
    GRANT_TYPE,
} from "../../../constants/constants";
import {
    API_ERROR,
    LOGIN_SUCCESS,
    LOGIN_USER,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
} from "./actionTypes";
import { post, postFormUrlencoded } from "helpers/api_helper";

import axios from "axios";
import { baseUrl } from "helpers/url_api_constant";
import { encryptData } from "helpers/cryptojs";

export const loginSuccess = payload => ({
    type: LOGIN_SUCCESS,
    payload,
});

export const logoutUser = payload => ({
    type: LOGOUT_USER,
    payload,
});

export const logoutUserSuccess = () => ({
    type: LOGOUT_USER_SUCCESS,
    payload: {},
});
export const apiError = payload => ({
    type: API_ERROR,
    payload,
});

export const loginUser = payload => ({
    type: LOGIN_USER,
    payload,
});

export const login = (values, history) => {
    return async dispatch => {
        dispatch(loadingAction.showLoading());
        try {
            dispatch(loginUser());
            const params = new URLSearchParams();
            params.append("grant_type", GRANT_TYPE);
            params.append("password", ACCESS_TOKEN_PASS);
            params.append("UserName", ACCESS_TOKEN_USER);
            let accessToken = await postFormUrlencoded(`${baseUrl}/token`, params);
            localStorage.setItem("accessToken", JSON.stringify(accessToken));
            let res = await post(
                `${baseUrl}api/Account/login?username=${encodeURIComponent(values.username)}&password=${encodeURIComponent(values.password)}`, {}
            );
            if (res.resultCode == 200) {

                let users = {
                    username: res.data.DISPLAY_NAME,
                    ...res.data,
                };

                localStorage.setItem("authUser", encryptData(users));
                dispatch(loginSuccess());
                history.push("/dashboard");
            } else {
                dispatch(apiError(res.resultDescription))
            }


        } catch (error) {
            console.log(error);
            dispatch(apiError(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };
};
export const logout = history => {
    return async dispatch => {
        try {
            localStorage.removeItem("authUser");
            localStorage.removeItem("accessToken");
            dispatch(logoutUserSuccess({}));
            history.push("/login");
        } catch (error) {}
    };
};